import { useState } from 'react';
import { QrCode } from 'lucide-react';
import QrCodeModal from './QrCodeModal';

interface Props {
  /** URL que codificará el QR. */
  value: string;
  /** Texto humano para identificar el QR (nombre del cliente, etc.). */
  label: string;
  /** Módulo de origen, p.ej. 'reputation'. */
  module: string;
  /** Id de la entidad origen (opcional). */
  refId?: string;
  /** Nombre base del archivo al guardar (opcional). */
  fileName?: string;
  /** Variante visual del botón. */
  variant?: 'outline' | 'icon';
  className?: string;
}

// Botón reutilizable: abre el modal de QR para cualquier URL del panel.
export default function QrCodeButton({ value, label, module, refId, fileName, variant = 'outline', className }: Props) {
  const [open, setOpen] = useState(false);
  const disabled = !value;

  const base = variant === 'icon'
    ? 'inline-flex items-center justify-center rounded-md border border-ui-border p-2 text-ui-text hover:bg-ui-text/[0.05] disabled:opacity-40'
    : 'inline-flex items-center gap-2 rounded-md border border-ui-border px-3 py-2 text-sm text-ui-text hover:bg-ui-text/[0.05] disabled:opacity-40';

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled}
        title="Generar código QR"
        className={`${base} ${className ?? ''}`}
      >
        <QrCode size={variant === 'icon' ? 16 : 14} />
        {variant === 'outline' && 'Código QR'}
      </button>
      {open && (
        <QrCodeModal value={value} label={label} module={module} refId={refId} fileName={fileName} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
